import { defineComponent as s, createElementBlock as o, openBlock as l, normalizeClass as d, renderSlot as n } from "vue";
const u = /* @__PURE__ */ s({
  name: "ll-box",
  __name: "Box",
  props: {
    disablePadding: { type: Boolean, default: !1 },
    disableGutters: { type: Boolean, default: !1 },
    disableElevation: { type: Boolean, default: !1 },
    radius: { default: "rounded" }
  },
  setup(t) {
    const e = t;
    return (a, r) => (l(), o("section", {
      class: d(["stash-box tw-bg-white", {
        "tw-rounded": e.radius === "rounded",
        "tw-p-gutter": !e.disablePadding && !e.disableGutters,
        "tw-py-gutter": e.disableGutters,
        "tw-shadow": !e.disableElevation
      }]),
      "data-test": "stash-box"
    }, [
      n(a.$slots, "default")
    ], 2));
  }
});
export {
  u as _
};
//# sourceMappingURL=Box.vue_vue_type_script_setup_true_lang-rFnvwLVY.js.map
